/**************************************************
 * Nombre:       Formulario_Respuestas_Test
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, ChatOutlined, CheckOutlined, Flag, Google} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSUSUARIOS} from "../../Constantes";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";

const Formulario_Respuestas_Test = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >





                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Pregunta'} dato={'pregunta'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={CheckOutlined} nombre={'Respuesta correcta'} dato={'correcta'} {...props}
                                  editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={ChatOutlined} nombre={'Respuesta escogida'} dato={'respuesta'} {...props}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Respuestas_Test